import type { Sticker } from "@/model/StickerType";
import { useGlobalI18n } from "@/translations/i18n";
import { findStickerType } from "@/utils/sticker";

const { t } = useGlobalI18n();

/**
 * Returns the human-readable name of a sticker — its backend label when
 * available, else a fallback derived from icon + color so the UI stays
 * usable. Hitting the fallback should not happen in production; when it does,
 * `findStickerType` reports it to Sentry as "Sticker type not found in store".
 */
export const stickerName = (sticker: Sticker | null): string => {
  if (!sticker) return t("stickerPicker.noSticker");
  const stickerType = findStickerType(sticker);
  if (stickerType) return stickerType.label;
  return t("label.stickyNote.sticker", { color: sticker.color, type: sticker.icon });
};
